import Divider from '@mui/material/Divider'
import Grid from '@mui/material/Grid2'
import Typography from '@mui/material/Typography'

import { BlockWrapper } from '../../../components/Wrapper/BlockWrapper'
import { ProjectArchiveList } from './components/ProjectArchiveList'

export const ProjectArchivePage = () => {
    return (
        <BlockWrapper>
            <Grid container sx={{ p: 2 }}>
                <Typography variant="h4">Архив проектов</Typography>
                <Divider sx={{ width: '100%', my: 2, height: ' 1px' }} />
            </Grid>

            <ProjectArchiveList />
        </BlockWrapper>
    )
}
